import React, { Component, Fragment } from 'react';
import styles from './styles.scss';
import { bool, string } from 'prop-types';

export default class GAChartTooltip extends Component {

    static propTypes = {
        isCompare: bool,
        chartValueLabel: string,
        changeLabel: string,
        firstValue: string, 
        secondValue: string,
        customLabel: string,
        customValue: string,
        dataChangeValue: string
    };

    static defaultProps = {
        changeLabel: "Change",
        isCompare: false
    };

    render() {
        const {
            isCompare,
            changeLabel,
            chartValueLabel,
            firstValue,
            secondValue,
            dataChangeValue,
            customLabel,
            customValue,
        } = this.props;

        return (
            <div data-test="tooltipChart" className={styles.boxTooltip}>
                {isCompare ?
                        <Fragment>
                            <div className={styles.choice}>{chartValueLabel}</div>
                            <div>
                                <div className={styles.rangeBox}>
                                    <span className={styles.visit}>&nbsp;</span>
                                    <div className={styles.date}>{"{time}"}</div>
                                    <div className={styles.value}>{`{${firstValue}}`}</div>
                                </div>
                                <hr className={styles.dividerTooltip}/>
                                <div>
                                    <div className={styles.choice}>{chartValueLabel}</div>
                                    <div className={styles.rangeBox}>
                                        <span className={styles.user}>&nbsp;</span>
                                        <div className={styles.date}>{"{timeComparison}"}</div>
                                        <div className={styles.value}>{`{${secondValue}}`}</div>
                                    </div>
                                    <div className={styles.rangeBox}>
                                        <div className={styles.changeLabel}>{changeLabel}</div>
                                        <div className={styles.percent}>{`{${dataChangeValue}}`}</div>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    :
                    (
                        <div>
                            <div data-test="tooltipChartTime" className={styles.title}>{"{time}"}</div>
                            <hr className={styles.dividerTooltip}/>
                            {
                                chartValueLabel && 
                                <div className={styles.firstChoice}>
                                    {chartValueLabel}: 
                                    <span data-test="tooltipChartFirstValue" className={styles.firstValue}>
                                        {`{${firstValue}}`}
                                    </span>
                                </div>
                            }   
                            {
                                customLabel && 
                                <div className={styles.firstChoice}>
                                    {customLabel}:
                                    <span data-test="tooltipChartCustomValue" className={styles.firstValue}>
                                        {`{${customValue}}`}
                                    </span>
                                </div>
                            }
                        </div>
                    )
                }
            </div>
        );
    }
}
